import $ from 'jquery'

class NewHeader {
    constructor() {
        this._isReduced = false;
        this._navOpened = false;
        this._searchOpened = false;
        this._isMobile = $(window).width() <= 769;
        this._isDesktop = $(window).width() > 769;
        this._header = $('[data-id="header"]');
        this._navBtn = $('[data-id="nav-btn"]');
        this._navItems = $('[data-id="nav-items"]');
        this._navFullItems = $('[data-id="nav-fullItems"]');
        this._searchInput = $('[data-id="search-input"]');
        this._searchClose = $('[data-id="search-close"]');
        this._searchBtn = $('[data-id="search-btn"]');
        this._searchForm = $('[data-id="search-form"]');

        this.init()
        this.bindEvents();
    }

    init() {
        let _this = this;
        let headerToFix = 'header';
        let adjustPadding = 48;
        let controlMenuClass = 'home';
        let headerToFixTop = $(headerToFix).offset().top;
        let headerToFixHeight = $(headerToFix).outerHeight();
        let headerToFixBottom = headerToFixTop + headerToFixHeight + adjustPadding;
        let headerReduced = $('#header').hasClass('is-reduced');

        $(window).on('scroll', function () {
            let scrollTop = $(window).scrollTop();

            if (_this._isDesktop) {
                if (scrollTop >= headerToFixBottom || headerReduced) {
                    if ($('body').hasClass(controlMenuClass)) {
                        $(".cscontent").css({
                            'paddingTop': headerToFixBottom
                        });
                    }
                    _this.reduceHeader();
                } else {
                    if ($('body').hasClass(controlMenuClass)) {
                        $(".cscontent").css({
                            'paddingTop': 0
                        });
                    }
                    _this.expandHeader();
                }
            }
        }).trigger("scroll");

        if (_this._isMobile) {
            _this._navItems.hide();
            _this._navFullItems.hide();
            _this._header.addClass('is-reduced');
            _this._isReduced = true;
            _this._navOpened = false;
        }
    }

    bindEvents() {
        let _this = this;

        _this._searchBtn.each(function() {
            let _searchBtn = $(this);
            _searchBtn.on('click', function() {
                _this.toggleSearch();
            });
        });

        _this._searchClose.on('click', function() {
            _this.closeSearch();
        });

        _this._navBtn.each(function() {
            let _navBtn = $(this);
            _navBtn.on('click', function() {
                _this.toggleNav();
            });
        });
    }

    reduceHeader() {
        this._header.addClass('is-reduced');
        $('body').addClass('header-fixed')
        this._isReduced = true;
    }

    expandHeader() {
        this._header.removeClass('is-reduced');
        $('body').removeClass('header-fixed');
        this._isReduced = false;
    }

    openNav() {
        let _this = this;

        _this.closeSearch();
        _this._navBtn.addClass('active');
        _this._navFullItems.show();
        _this._navOpened = true;
        $('body').addClass("no-scroll nav-open");
        if (_this._isMobile) {
            _this._searchForm.show();
        }
    };

    closeNav() {
        let _this = this;

        _this._navBtn.removeClass('active');
        _this._navFullItems.hide();
        _this._navOpened = false;
        $('body').removeClass("no-scroll nav-open");
    };

    toggleNav() {
        this._navOpened ? this.closeNav() : this.openNav();
    };

    openSearch() {
        let _this = this;

        _this._searchForm.show();
        _this._searchInput.focus();
        _this._searchOpened = true;

        _this.closeNav();
    };

    closeSearch() {
        this._searchForm.hide();
        this._searchOpened = false;
    };

    toggleSearch() {
        let _this = this;

        _this._searchOpened ? _this.closeSearch() : _this.openSearch();
    }
}

export default NewHeader;
